import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconDisconnect = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 17} height={props.height || 16} viewBox="0 0 17 16" fill="none">
      <path
        d="M6.5 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V3.33333C2.5 2.97971 2.64048 2.64057 2.89052 2.39052C3.14057 2.14048 3.47971 2 3.83333 2H6.5"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1667 11.3334L14.5 8.00008L11.1667 4.66675"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 8H6.5"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
